var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles.renderingArea)},[_c('img',{directives:[{name:"gallery",rawName:"v-gallery"}],style:({width: (_vm.innerWidth - 20) + 'px', height: (_vm.innerHeight - 20) + 'px'}),attrs:{"src":_vm.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20f5835a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/misc/components/ImgViewer.vue
// module id = null
// module chunks = 